import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ContentChild, input, output, TemplateRef } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { HasPermissionDirective } from '../../../directives/has-permission.directive';
import { HasPermissionConfig } from '../../../types/permission.types';
import { CesButtonComponent } from '../ces-buttons/ces-button.component';
import { CesMenuButtonSecondaryComponent } from '../ces-buttons/ces-menu-button-secondary.component';

@Component({
  selector: 'ces-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ces-card.component.html',
  imports: [CommonModule, CesButtonComponent, CesMenuButtonSecondaryComponent, HasPermissionDirective],
  styleUrl: './ces-card.component.scss',
})
export class CesCard {
  readonly title = input('');
  readonly bodyTitle = input('');
  readonly bodyDescription = input('');
  readonly footer = input('');
  readonly items = input<MenuItem[] | undefined>();
  readonly innerClass = input<string>();
  readonly clickable = input(false);
  readonly hasPermission = input<HasPermissionConfig>();
  readonly href = input<string | null>(null);

  @ContentChild('header') headerTemplate?: TemplateRef<unknown>;
  @ContentChild('title') titleTemplate?: TemplateRef<unknown>;
  @ContentChild('action') actionTemplate?: TemplateRef<unknown>;
  @ContentChild('body') bodyTemplate?: TemplateRef<unknown>;
  @ContentChild('footer') footerTemplate?: TemplateRef<unknown>;

  cardClick = output<Event>();

  readonly wrapperClass = computed(() => {
    const classes = [];
    if (this.innerClass()) classes.push(this.innerClass());
    if (this.clickable()) classes.push('clickable', 'cursor-pointer');
    return classes.join(' ');
  });

  clickAction(e: Event) {
    if (e instanceof KeyboardEvent) {
      e.preventDefault();
    }
    e.stopPropagation();
    this.cardClick.emit(e);
  }

  onLinkClick(event: MouseEvent): void {
    // Modified or non-primary clicks fall through to the browser so the href opens in a new tab/window.
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) {
      return;
    }
    // Plain click keeps in-app navigation and its side effects instead of a full page load.
    event.preventDefault();
    event.stopPropagation();
    this.cardClick.emit(event);
  }
}
